import {
  styled, rem
} from 'config/stitches.config'

export const StyledMediaWithTagImage = styled('div', { marginTop: rem(120) })
